import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Container, Grid } from "@mui/material"; // Import Grid for better layout
import { notes } from "./writing";
import NoteCard from "./components/NoteCard";
import NotesHeader from "./components/NoteHeader";

function Notes() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        pt: "100px",
        pb: "100px",
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        display: "flex",
        justifyContent: "center" // Centers content on wide screens
      }}
    >
      {/* Container controls max-width and responsive padding automatically */}
      <Container maxWidth="md"> 
        
        <NotesHeader />

        {/* Optional: Use Grid to show 2 notes per row on desktop? 
           If you want a list, keep your <ul>. If you want a grid, use this:
        */}
        <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
          {notes.map(note => (
            <Box component="li" key={note.id} sx={{ mb: 2 }}>
              <NoteCard note={note} />
            </Box>
          ))}
        </Box>

      </Container>
    </Box>
  );
}

export default Notes;